/**
 * Created by renming on 2017/6/28.
 */
import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import com from './modules/com';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    com
  },
  state:{
    map:{},
    mapOption:{
      style: "",
      center: [117.2044388492535, 39.124940370584596],
      zoom: 13.570821892259337,
      pitch: 0,
      bearing: 0,
      attributionControl:false
    }
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js